;(function () {
  'use strict'

  angular
    .module('contrast.integrations')
    .factory('WebhookFactory', ['$http', 'UserService', WebhookFactory])

  function WebhookFactory($http, UserService) {
    var factory = {
      addWebhook: addWebhook,
      deleteIntegration: deleteIntegration,
      editWebhook: editWebhook,
      getWebhook: getWebhook,
      getWebhooks: getWebhooks,
      testWebhook: testWebhook
    }

    return factory

    function addWebhook(webhook) {
      return $http.post(UserService.buildAPIUrl('/webhooks'), webhook)
    }

    function deleteIntegration(id) {
      return $http['delete'](UserService.buildAPIUrl('/webhooks/' + id))
    }

    function editWebhook(id, webhook) {
      return $http.put(UserService.buildAPIUrl('/webhooks/' + id), webhook)
    }

    function getWebhook(id) {
      return $http.get(UserService.buildAPIUrl('/webhooks/' + id), {
        params: { expand: 'webhook_apps' }
      })
    }

    function getWebhooks() {
      return $http.get(UserService.buildAPIUrl('/webhooks'), {
        params: { expand: 'webhook_apps' }
      })
    }

    function testWebhook(data) {
      return $http.post(UserService.buildAPIUrl('/webhooks/test'), data)
    }
  }
})()
